import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { toast } from 'sonner';

const API = '/api';
const RED = '#b91d47', RED_D = '#8f1538', INK = '#1c1c28', GREY = '#7a7a8c';

export default function AppEditProfile() {
  const navigate = useNavigate();
  const phone = localStorage.getItem('userPhone') || '';
  const [name, setName] = useState(localStorage.getItem('userName') || '');
  const [email, setEmail] = useState(localStorage.getItem('userEmail') || '');
  const [gender, setGender] = useState(localStorage.getItem('userGender') || '');
  const [saving, setSaving] = useState(false);

  const save = async () => {
    if (!name.trim()) { toast.error('Please enter your name'); return; }
    setSaving(true);
    try {
      localStorage.setItem('userName', name.trim());
      localStorage.setItem('userEmail', email.trim());
      localStorage.setItem('userGender', gender);
      try {
        await axios.post(`${API}/user/update-profile`, {
          phone, name: name.trim(), email: email.trim(), gender,
        }, { timeout: 10000 });
      } catch (e) { /* saved locally regardless */ }
      toast.success('Profile updated');
      navigate('/app/profile');
    } catch (e) {
      toast.error('Could not save. Try again.');
    }
    setSaving(false);
  };

  const field = (label, value, setter, type = 'text', placeholder = '') => (
    <div style={{ marginBottom: 18 }}>
      <label style={{ fontSize: 13, fontWeight: 700, color: GREY, display: 'block', marginBottom: 8 }}>{label}</label>
      <input type={type} value={value} onChange={e => setter(e.target.value)} placeholder={placeholder}
        style={{ width: '100%', background: '#fff', border: '1.5px solid #f0f0f4', borderRadius: 12, padding: '14px 16px', fontSize: 15, color: INK, outline: 'none', boxSizing: 'border-box' }} />
    </div>
  );

  return (
    <div style={{ minHeight: '100vh', background: '#f4f6fb', maxWidth: 480, margin: '0 auto' }}>
      <div style={{ background: `linear-gradient(135deg,${RED},${RED_D})`, color: '#fff', padding: '20px 16px', display: 'flex', alignItems: 'center', gap: 14 }}>
        <span onClick={() => navigate('/app/profile')} style={{ fontSize: 24, cursor: 'pointer' }}>‹</span>
        <div style={{ fontSize: 18, fontWeight: 700 }}>Edit Profile</div>
      </div>

      <div style={{ padding: 20 }}>
        {/* avatar */}
        <div style={{ textAlign: 'center', marginBottom: 24 }}>
          <div style={{ width: 80, height: 80, borderRadius: '50%', background: `linear-gradient(135deg,${RED},${RED_D})`, color: '#fff', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 34, fontWeight: 800, margin: '0 auto' }}>
            {(name || 'U').charAt(0).toUpperCase()}
          </div>
        </div>

        {field('Full Name', name, setName, 'text', 'Enter your name')}

        <div style={{ marginBottom: 18 }}>
          <label style={{ fontSize: 13, fontWeight: 700, color: GREY, display: 'block', marginBottom: 8 }}>Phone Number</label>
          <input value={`+91 ${phone}`} disabled style={{ width: '100%', background: '#f0f0f4', border: '1.5px solid #f0f0f4', borderRadius: 12, padding: '14px 16px', fontSize: 15, color: GREY, outline: 'none', boxSizing: 'border-box' }} />
          <div style={{ fontSize: 11, color: GREY, marginTop: 6 }}>Phone number cannot be changed</div>
        </div>

        {field('Email (optional)', email, setEmail, 'email', 'you@example.com')}

        <div style={{ marginBottom: 24 }}>
          <label style={{ fontSize: 13, fontWeight: 700, color: GREY, display: 'block', marginBottom: 8 }}>Gender (optional)</label>
          <div style={{ display: 'flex', gap: 10 }}>
            {['Male', 'Female', 'Other'].map(g => (
              <button key={g} onClick={() => setGender(g)} style={{ flex: 1, padding: '12px', borderRadius: 12, border: gender === g ? `1.5px solid ${RED}` : '1.5px solid #f0f0f4', background: gender === g ? '#fdf2f5' : '#fff', color: gender === g ? RED : INK, fontWeight: 700, fontSize: 14, cursor: 'pointer' }}>{g}</button>
            ))}
          </div>
        </div>

        <button onClick={save} disabled={saving} style={{ background: `linear-gradient(135deg,${RED},${RED_D})`, color: '#fff', border: 'none', borderRadius: 14, padding: 16, fontSize: 16, fontWeight: 700, width: '100%', cursor: 'pointer', boxShadow: '0 8px 20px rgba(185,29,71,.3)', opacity: saving ? 0.7 : 1 }}>
          {saving ? 'Saving...' : 'Save Changes'}
        </button>
      </div>
    </div>
  );
}
